// Entry file
/* eslint-disable @atlaskit/editor/no-re-export */

import { getConversationStarters } from '@atlaskit/rovo-agent-components';
// Testing data until we start to load it from client.
export { ChatAgent, CommsCrafterAgent, JobWriterAgent, A11yMateAgent } from './mock-agents';
/**
 * Pulls out the necessary fields from the raw agent data received to create an EditorAgent.
 * We can use this to populate additional fields like color, iconInitials etc.
 *
 * @param agent
 */
export var getEditorAgent = function getEditorAgent(agent) {
  var _agent$user_defined_c;
  var id = agent.id,
    name = agent.name,
    description = agent.description,
    named_id = agent.named_id,
    creator_type = agent.creator_type,
    system_prompt_template = agent.system_prompt_template,
    creator = agent.creator,
    visibility = agent.visibility,
    is_default = agent.is_default,
    identity_account_id = agent.identity_account_id,
    icon = agent.icon;
  return {
    id: id,
    name: name,
    description: description,
    namedId: named_id,
    creatorType: creator_type,
    systemPromptTemplate: system_prompt_template,
    creator: creator !== null && creator !== void 0 ? creator : undefined,
    visibility: visibility,
    isDefault: is_default,
    identityAccountId: identity_account_id,
    icon: icon,
    conversationStarters: getConversationStarters({
      isAgentDefault: is_default,
      userDefinedConversationStarters: (_agent$user_defined_c = agent.user_defined_conversation_starters) === null || _agent$user_defined_c === void 0 ? void 0 : _agent$user_defined_c.map(function (starter) {
        return {
          message: starter,
          type: 'user-defined'
        };
      })
    }).combinedConversationStarters,
    externalConfigReference: agent.external_config_reference
  };
};